import { AdminAbilities, DocReviewAbilities, ParalegalAbilities } from '../components/Can/ability';

import { Auth } from '@aws-amplify/auth';

export const authService = {
    login,
    logout,
    completeNewPasswordChallenge,
};

export const completeNewPasswordChallenge = (password, attributes, credentials) => {
    attributes = {
        ...attributes,
        'custom:isAdmin': '1',
    };
    if ((password, attributes, credentials)) {
        return Auth.signIn(credentials.username, credentials.password);
    }

    throw 'Failure';
};

export const login = (username, password) => {
    return Auth.signIn(username, password).then(user => {
        if (user.challengeName) {
            const { challengeName } = user;
            const error = {
                ...user,
                code: challengeName,
            };
            throw error;
        }

        return user.getUserAttributes((err, result) => {
            if (err) {
                throw err;
            }
            const { username } = user;
            const userDetails = { username };
            for (let i = 0; i < result.length; i++) {
                const key = result[i].getName();
                const value = result[i].getValue();
                if (key.indexOf('custom:') === 0) {
                    const customKey = key.split(':').slice(1).join(':');
                    userDetails[customKey] = value;
                } else {
                    userDetails[key] = value;
                }
            }

            if (userDetails['isAdmin'] === '1') {
                user.abilities = AdminAbilities;
            } else if (userDetails['isDocReview'] === '1') {
                user.abilities = DocReviewAbilities;
            } else {
                user.abilities = ParalegalAbilities;
            }

            return user;
        });
    });
};

export const logout = () => {
    return Auth.signOut();
};
